import { useTranslation } from 'react-i18next'

export const FormFooter = () => {
	const { t } = useTranslation('chat')

	return (
		<div className="mt-3 px-3 pb-3 text-center text-xs text-black/50 md:px-4 md:pb-6">
			<span>{t('disclaimer')}</span>
		</div>
	)
}
